import * as React from 'react';
import { SystemValidator } from '../common/SystemValidator';
import { IValidationTypes } from '../types/IValidationTypes';
import { ISystemBase } from '../types/ISystemBase';
import { IValueMultiObject, IValueObject } from '../types/IDynamicList';
import { formatLabel } from '../helpers/utils'
import { SuperAdminInfo } from '../common/ShowAdminInfo';
import { isDate } from 'moment';
import moment from 'moment';
import SystemLanguage from '../form/AddSystemLanguage/SystemLanguage';

/*
 * The base class for base components with necessary styling and functions
 * */
interface ISystemBaseState {
    isError?: boolean,
    inFocus?: boolean,
    errorMessage?: string[],
    isDirty?: boolean,
    isValid?: boolean,
    validators?: IValidationTypes[],
    value?: any,
    defaultValue?: any,
    rawValue?: any,
    isLoading?: false
    lookupSelecteddata?: IValueObject[],
    ListItemsMulti: []
    language: [],
    visible: false

}

const showConsoleInfo = false;



export abstract class SystemBase<T = {}, S = {}> extends React.PureComponent<ISystemBase & T, any /* S & ISystemBaseState */, any> {
    timeoutref: any = null;

    static defaultProps: any = {

        disabled: false,
        id: '',
        name: '',
        labelClass: 'col-sm-3',
        componentClass: 'col-sm-9',
        isControlledMode: true,
    };

    constructor(props: ISystemBase & T) {
        super(props);
        this.state = {
            isError: false,
            inFocus: false,
            isLoading: false,
            isDirty: false,
            isValid: true,
            errorMessage: [] as string[],
            validators: [] as IValidationTypes[],
            value: props.value,
            defaultValue: props.value,
            lookupSelecteddata: [] as IValueObject[],
            ListItemsMulti: [] as IValueMultiObject[],
            language: [] as IValueMultiObject[],
            visible: false

        } as ISystemBaseState & S;
        this.validate = this.validate.bind(this);
        if (props.validator) props.validator(props.name, this.validate)

    }
    setupValidators = () => {
        let validators: IValidationTypes[] = [];

        if (this.props.isRequired)
            validators.push({
                type: "REQUIRED",
                message: `${this.props.label} is a required field`,
                value: ""
            });

        if (this.props.minLength)
            validators.push({
                type: "MIN_LENGTH",
                message: `${this.props.label} should be atleast ${this.props.minLength} char(s) long`,
                value: this.props.minLength
            });

        if (this.props.maxLength)
            validators.push({
                type: "MAX_LENGTH",
                message: `${this.props.label} should be less than ${this.props.maxLength} char(s) long`,
                value: this.props.maxLength
            });

        if (this.props.minValue)
            validators.push({
                type: "MIN_VALUE",
                message: `${this.props.label} should be greater than ${isDate(this.props.minValue) === true ? `${moment(this.props.minValue).format("DD/MM/YYYY")}` : `${this.props.minValue - 1}`}`,
                value: this.props.minValue
            });

        if (this.props.maxValue)
            validators.push({
                type: "MAX_VALUE",
                message: `${this.props.label} should be less than ${this.props.maxValue}`,
                value: this.props.maxValue
            });

        if (this.props.isEmail)
            validators.push({
                type: "EMAIL",
                message: `${this.props.label} is not a valid Email`,
                value: ""
            });

        if (this.props.validators && this.props.validators.length > 0)
            this.props.validators.forEach((item) => validators.push(item));

        this.setState({ validators: validators });

    };

    GetTranslatedLanguage = async () => {
        //var lang = getSettingValue("Language").toUpperCase();        
        var lang = sessionStorage.getItem('UserSystemLanguage');
        var globlizationData = sessionStorage.getItem('Globalizations');
        if (globlizationData != 'Data not exist!') {
            var GlobalizationsList = JSON.parse(sessionStorage.getItem('Globalizations') || "[{}]");
            if (lang && lang !== "En") {
                if (GlobalizationsList && GlobalizationsList.length > 0) {
                    this.setState({
                        language: GlobalizationsList,
                    })
                    sessionStorage.setItem("Globalizations", JSON.stringify(GlobalizationsList))
                }
            }
        }
    //    if (lang !== "En") {
    //        await HttpService.get('/Common/ListByLanguage/' + lang).then(response => {
    //            if (response.status == 200) {
    //                this.setState({
    //                    language: response.data,
    //                })
    //                localStorage.setItem("list", JSON.stringify(response.data))
    //            }
    //        }).catch(err => console.log(err))
    //    }
    }


    componentDidMount() {
        this.handleDidMount();
    }

    addValidator = () => this.props.validator && this.props.validator(this.props.id + "." + this.props.name, this.validate, false);
    removeValidator = () => this.props.validator && this.props.validator(this.props.id + "." + this.props.name, this.validate, true);

    componentWillUnmount = () => this.removeValidator();

    handleDidMount() {
        this.setupValidators();
        this.addValidator();
        this.handleValueChange(false);
        this.GetTranslatedLanguage();

        //const SystemLanguage = localStorage.getItem('SystemLanguage');
        //this.setState({
        //    systemLanguage: SystemLanguage
        //})
    }

    handleDidUpdate(prevProps: ISystemBase & T) {
        if (prevProps.validators != this.props.validators ||
            prevProps.isRequired != this.props.isRequired ||
            prevProps.minLength != this.props.minLength ||
            prevProps.maxLength != this.props.maxLength ||
            prevProps.exactLength != this.props.exactLength ||
            prevProps.minValue != this.props.minValue ||
            prevProps.maxValue != this.props.maxValue ||
            prevProps.isEmail != this.props.isEmail)
            this.setupValidators();

        if (prevProps.value != this.props.value) {
            this.handleValueChange(true);
        }

        if (prevProps.validator != this.props.validator)
            this.addValidator();
    }

    componentDidUpdate(prevProps: ISystemBase & T) {
        this.handleDidUpdate(prevProps);

    }

    handleValueChange = (validate: boolean = true) => {
        let isMaskInputBox = this.props.mask ? true : false;
        this.setState({
            value: this.props.value,
            rawValue: isMaskInputBox && this.props.value && typeof this.props.value == "string" ? this.props.value.replace(/[- \(\)\+]/g, '') : this.props.value,
            defaultValue: this.props.defaultValue
        }, () => {
            if (validate) this.validate();
        });
    };




    // returns a unique key with a prefix applied
    public generateKey = () => `${Math.random()}_${new Date().getTime()}`;

    handleOpen = () => {
        this.setState({ visible: true })
        /*localStorage.setItem("LableName", this.props.label || "")*/
    }
    handleClose = () => {
        this.setState({ visible: false })
    }
    // html to be shwon in case of required components
    public requiredHtml = () => this.props.isRequired ? <><span className="required text-red">*</span></> : '';
    TranslatedText = () => {
        var lang = sessionStorage.getItem('UserSystemLanguage');
        if (lang !== "En") {
            var arr = [];
            const jsonToObj = JSON.parse(sessionStorage.getItem("Globalizations") || "[{}]");
            arr = [...jsonToObj]
            if (this.props.label && arr.length > 0) {               
                let data = arr.find((i: any) => i.EnglishText === this.props.label && i.Language === lang);
                if (data) {
                    return data.TranslatedText;// (data. ? data : this.props.label);
                }
                else {
                   return this.props.label;
                }
            }
            return this.props.label;
        } else {
            return this.props.label;
        }

        //if (this.props.label) {
        //    var x:any = this.props.label 
        //    var lang = localStorage.getItem('SystemLanguage') || "En";
        //    if (lang === "Ar") {
        //        HttpService.get('/Common/GetTranslation/' + this.props.label).then(response => {
        //            if (response.status == 200) {
        //                alert(1)
        //                x = response.data.TranslatedText
        //                console.log(x)
        //                return x
        //            }
        //        })
        //    }
        //   return x;
        //}
    }


    // the complete label part of the component
    public LabelComponent = () => {
        var lbl1 = typeof this.props.label == 'string' ? formatLabel(this.TranslatedText(), this.props.labelFormat as string) : this.TranslatedText();
        var lbl2 = this.props.hideAdminInfo != true ? <SuperAdminInfo {...this.props} label={lbl1} /> : lbl1;


        // var lbl1 = typeof this.props.label == 'string' ? formatLabel( this.props.label, this.props.labelFormat as string) : this.props.label;
        //var lbl2 = this.props.hideAdminInfo != true ? <SuperAdminInfo {...this.props} label={lbl1} /> : lbl1;

        return <label htmlFor={this.props.name}
            className={this.props.labelClass + (sessionStorage.getItem('UserSystemLanguage') === "Ar" ? " col-form-label ar-lable" : " col-form-label") + (this.state.inFocus ? " label-infocus-highlight" : "")}>
            {lbl2} : {this.requiredHtml()} </label >;
    }

    public ErrorMessage = (msg: string) => <span key="errormessage" className={`is-invalid ${sessionStorage.getItem('UserSystemLanguage') == 'Ar' ? 'ar-error-msg' : ''}`}>{msg}</span>;
    // Wrapps the Component with default styling 
    public WrapperDiv = (p: any) => {

        return <>

            <div className={"form-group row"}>
                {/*{!this.props.hideLabel && this.LabelComponent()} <span className="form-detail-info" >{p.tooltipComponent}</span>*/}
                {!this.props.hideLabel && this.LabelComponent()}
                <div
                    className={[
                        this.props.hideLabel ? 'col-sm-12 ' : this.props.componentClass + ' ',
                        this.state.inFocus ? 'focused' : '',
                        this.state.isValid ? "valid" : "is-invalid-input"]
                        .join(" ")} >
                    {p.children}
                    {this.props.showCharacterCount && this.props.value && this.props.maxLength &&
                        <div className="textarea-character-count">
                            <span >{this.props.value.toString().length + '/' + this.props.maxLength} </span>
                        </div>
                    }
                    {!this.state.isValid && this.state.errorMessage ?
                        this.state.errorMessage
                            .filter((msg: string) => msg.trim() != '')
                            .map((msg: string) => this.ErrorMessage(msg)) : null}
                </div>
            </div>
        </>;

    };


    public isNullOrUndefined = (value: any) => value == null || value == undefined;


    updateBaseState = (event?: any, value: any = undefined, text: string = '') => {
        this.setState({ ...this.state, value: value, isDirty: true },
            () => {
                if (this.props.onChange)
                    this.props.onChange(event, this.props.name, value, text);

                this.validate();
            }
        );
    }

    // pass on the onChange event to parent
    public handleChange = (event?: any, customValue: any = undefined, text: string = '') => {
        let value = customValue || (event && event.target && event.target.value) || undefined
        // to fix 0 value error
        if (event && event.target && this.isNullOrUndefined(value) && !this.isNullOrUndefined(event.target.value)) value = event.target.value

        this.updateBaseState(event, value, text)
    };

    // pass on the onChange event to parent
    public handleChangeSwtich = (event?: any, value: any = undefined, text: string = '') => {
        this.updateBaseState(event, event.value, text)
    };

    public handleChangeCheckBox = (event?: any, value: any = undefined, text: string = '') => {
        //let value = event.value == true ? event.value : false
        //this.updateBaseState(event, value && value == true ? true : false, text)
        this.updateBaseState(event, event.value == true, text)
    };

    // pass on the onChange event to parent
    onKeyPress = (event: any, customValue: any = undefined, text: string = '') => {
        if (this.props.onKeyPress)
            this.props.onKeyPress(event);
    }
    // validate the input 
    public validate(): boolean {
        let valid = true;
        var messages: string[] = [];
        this.state.validators.every((item: any) => {
            if (SystemValidator.validate(item, this.state.value)) return true;
            valid = false;
            messages.push(item.message);
            return false;
        });

        this.setState({ errorMessage: [...messages], isValid: valid });
        if (this.props.onValidate) this.props.onValidate(valid);
        return valid;
    }


    // handle the input focus
    public handleFocus = (event: any) => {
        if (this.timeoutref) clearTimeout(this.timeoutref);
        this.timeoutref = setTimeout(() => this.setState({ ...this.state, inFocus: true }), 10);
        this.props.onFocus && this.props.onFocus();
    };

    // handle the input exit
    public handleBlur = (event: any) => {
        if (this.timeoutref) clearTimeout(this.timeoutref);
        this.timeoutref = setTimeout(() => {
            let valid = this.validate();
            this.setState({ inFocus: false, isValid: valid }, () => {
                if (this.props.onValidate) this.props.onValidate(valid);
            });
        }, 10);
        this.props.onBlur && this.props.onBlur(event);
    };

    //            log(message?: any, ...optionalParams: any[]): void;
    log = (fname: string, a?, b?, c?, d?, e?, f?, g?, h?) => {
        showConsoleInfo && console.log(
            `System Base - ${fname} => Name : ${this.props.name} | Prop Value : ${this.props.value} | State Value : ${this.state.value} | IsValid : ${this.state.isValid}`, this.state.validators, a, b, c, d, e, f, g, h)
    }
}


